import React from "react";
import styled from "styled-components";
import Spinner from "./Spinner";

const FullPageLoader = () => {
  return (
    <StyledLoaderWrapper>
      <Spinner />
    </StyledLoaderWrapper>
  );
};

export default FullPageLoader;

const StyledLoaderWrapper = styled.div`
  height: 65vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;
